import ReactDOM from 'react-dom/client';
import './index.css';
import './component/tatoodashboard/tatoodashboard.css';
import App from './App';
import './component/piercingdashboard/piercing.css'
import { StrictMode } from 'react';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <StrictMode>
    <App />
  //  </StrictMode>
);
